import { createApp } from "vue";
import App from "./App.vue";
import * as directive from '@/directive/permission/index'
// import Tooltip from '@/directive/tooltip'
import PopoverDirective from '@/directive/tooltipDirective'

import mitt from 'mitt';


/*
TIP: To get started with clean router change path to @/router/clean.ts.
 */
import router from "./router";
import store from "./store";
import ElementPlus from "element-plus";


//imports for app initialization
import ApiService from "@/core/services/ApiService";
import { initApexCharts } from "@/core/plugins/apexcharts";
import { initInlineSvg } from "@/core/plugins/inline-svg";
import { initVeeValidate } from "@/core/plugins/vee-validate";
// import 'bootstrap/dist/css/bootstrap.min.css'
// import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import "bootstrap";
// Class chuẩn giao diện admin (form 32/13, bảng, banner, badge số…) — xem STYLE_REFACTOR_2026.md
import "@/assets/css/umt-ui-standard.css";


// Element Plus v1 (beta): el-select trong mounted chạy nextTick đọc reference.$el;
// khi select mount-rồi-unmount trong cùng nhịp (v-if lật lúc đổ dữ liệu) thì ref = null
// -> "Cannot read properties of null (reading '$el')" (unhandled promise, VÔ HẠI nhưng spam console).
// Không nâng được element-plus (v1 beta, app phụ thuộc API cũ) nên chặn đúng lỗi này ở tầng app.
window.addEventListener("unhandledrejection", (e) => {
  if (e.reason instanceof TypeError && /reading '\$el'/.test(e.reason.message || "")) {
    e.preventDefault();
  }
});

const app = createApp(App);
export const emitter = mitt();
app.config.globalProperties.emitter = emitter;
(app.config as any).devtools = false;
app.use(store);
app.directive('tooltip', PopoverDirective)
app.use(router);
app.use(ElementPlus as any);

app.directive('permission', directive.default.permission)
app.directive('role', directive.default.role)

ApiService.init(app);
initApexCharts(app);
initInlineSvg(app);
initVeeValidate();



app.mount("#app");

// Tránh cảnh báo Chrome "Blocked aria-hidden on an element ... descendant retained focus":
// Bootstrap/Metronic gán aria-hidden khi đóng/mở modal trong khi phần tử con vẫn đang focus.
// Khi 1 phần tử nhận aria-hidden="true" mà đang chứa activeElement → bỏ focus phần tử đó.
const ariaHiddenFocusGuard = new MutationObserver((mutations) => {
  mutations.forEach((m) => {
    const el = m.target as HTMLElement;
    if (m.attributeName === "aria-hidden" && el.getAttribute("aria-hidden") === "true") {
      const active = document.activeElement as HTMLElement | null;
      if (active && active !== document.body && el.contains(active)) {
        active.blur();
      }
    }
  });
});
ariaHiddenFocusGuard.observe(document.body, {
  subtree: true,
  attributes: true,
  attributeFilter: ["aria-hidden"],
});

